"use client";

import { asText } from "@prismicio/client";
import { Accordion, unstyledRichTextComponents } from "@up/ui";

import CTAButton from "~/components/CTAButton";
import RichText from "~/components/RichText";

export default function AccordionSlice({ slice }) {
  const decoratedSlice = {
    ...slice,
    items: slice.items.map((item) => ({
      ...item,
      heading: asText(item.heading),
    })),
  };

  return (
    <div className="max-875 mx-auto">
      {slice.primary.category ? (
        <div className="mb-4">
          <RichText field={slice.primary.category} />
        </div>
      ) : null}

      <div className="rte">
        <Accordion
          CTA={CTAButton}
          richTextComponents={unstyledRichTextComponents}
          slice={decoratedSlice}
        />
      </div>
    </div>
  );
}
